import { useEffect, useState } from 'react';
import { Kbd } from './kit.tsx';

/** Debounced search field; `/` focuses it from anywhere on the page. */
export function SearchBox({ value, onChange, placeholder }: { value: string; onChange: (value: string) => void; placeholder: string }) {
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [value]);
  useEffect(() => {
    if (draft === value) return;
    const timer = window.setTimeout(() => onChange(draft), 250);
    return () => window.clearTimeout(timer);
  }, [draft, value, onChange]);
  return (
    <label className="search">
      <span className="visually-hidden">{placeholder}</span>
      <input
        type="search"
        data-search
        value={draft}
        placeholder={placeholder}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') (e.target as HTMLInputElement).blur();
        }}
      />
      <Kbd>/</Kbd>
    </label>
  );
}
